module.exports = __webpack_public_path__ + "img/Alex.a894acfa.png";